import React from 'react';
import { getConfig } from 'config/getConfig';
import { Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey } from '@fortawesome/free-solid-svg-icons';

const OidcLogin = () => {
  // PKCE helpers
  const base64UrlEncode = (arrayBuffer) => {
    const bytes = new Uint8Array(arrayBuffer);
    let binary = '';
    bytes.forEach(b => binary += String.fromCharCode(b));
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  };

  const generateCodeVerifier = (length = 64) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    const randomValues = new Uint32Array(length);
    window.crypto.getRandomValues(randomValues);
    let verifier = '';
    for (let i = 0; i < length; i++) {
      verifier += chars[randomValues[i] % chars.length];
    }
    return verifier;
  };

  const generateCodeChallenge = async (verifier) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(verifier);
    const digest = await window.crypto.subtle.digest('SHA-256', data);
    return base64UrlEncode(digest);
  };

  const handleOidcLogin = async () => {
    // 런타임 설정 우선 적용
    const { SSO_KEYCLOAK_URL, SSO_REALM, SSO_CLIENT_ID } = getConfig();
    const keycloakUrl = SSO_KEYCLOAK_URL;
    const realm = SSO_REALM;
    const clientId = SSO_CLIENT_ID;
    const redirectUri = `${window.location.origin}/oidc/callback`;

    // PKCE (S256) 생성
    const codeVerifier = generateCodeVerifier();
    const codeChallenge = await generateCodeChallenge(codeVerifier);
    sessionStorage.setItem('pkce_code_verifier', codeVerifier);
    // 새 탭/리로드 대비 로컬에도 보관 (콜백에서 보조)
    try { localStorage.setItem('pkce_code_verifier', codeVerifier); } catch (e) { /* no-op */ }

    const authUrl = `${keycloakUrl}/realms/${realm}/protocol/openid-connect/auth?` +
      `response_type=code&` +
      `client_id=${clientId}&` +
      `redirect_uri=${encodeURIComponent(redirectUri)}&` +
      `scope=openid%20profile%20email&` +
      `code_challenge=${encodeURIComponent(codeChallenge)}&` +
      `code_challenge_method=S256`;

    console.log('OIDC Login - Environment Variables:', {
      keycloakUrl,
      realm,
      clientId,
      redirectUri,
      authUrl
    });

    window.location.href = authUrl;
  };

  return (
    <Form>
      <div className="text-center mb-4">
        <FontAwesomeIcon
          icon={faKey}
          size="3x"
          className="text-primary mb-3"
        />
        <h4 className="text-center mt-3">SSO 로그인</h4>
        <p className="text-center text-muted mb-4">통합 인증 시스템으로 로그인합니다.</p>
      </div>

      <Button
        variant="primary"
        className="w-100 mt-3"
        onClick={handleOidcLogin}
      >
        <FontAwesomeIcon icon={faKey} className="me-2" />
        Keycloak으로 로그인
      </Button>

      <div className="text-center mt-3">
        <small className="text-muted">
          OIDC (OpenID Connect) 표준 인증을 사용합니다
        </small>
      </div>
    </Form>
  );
};

export default OidcLogin;
